import { defineMessages } from '../../TypedIntl'

export const messages = defineMessages({
  title: 'FollowUp.ReportSent.summary.title',
  reportId: 'FollowUp.ReportSent.summary.reportId',
  status: 'FollowUp.ReportSent.summary.status',
  reported: 'FollowUp.ReportSent.summary.reported',
  lastAction: 'FollowUp.ReportSent.summary.lastAction',
  senderIdentity: 'FollowUp.ReportSent.summary.senderIdentity',
  anonymous: 'Shared.chat.anonymous',
  sentInformation: 'FollowUp.ReportSent.summary.sentInformation',
  victimName: 'Shared.report.victimName',
  category: 'Shared.report.category',
  moreInfo: 'Shared.report.moreInfo',
  attachments: 'Shared.report.attachments',
  organizationalUnit: 'Shared.report.organization',
  classRoom: 'Shared.report.classRoom',
})
